import { Feature, MultiPolygon, Polygon } from "geojson";

import { difference, polygon } from "fond/turf";

/**
 * The latitude bounds of the Web Mercator projection.
 */
const MERCATOR_MAX_LATITUDE = 85.051129;

const WORLD = polygon([
  [
    [-180, -MERCATOR_MAX_LATITUDE],
    [180, -MERCATOR_MAX_LATITUDE],
    [180, MERCATOR_MAX_LATITUDE],
    [-180, MERCATOR_MAX_LATITUDE],
    [-180, -MERCATOR_MAX_LATITUDE],
  ],
]);

/**
 * Return a polygon representing the area outside the given polygon.
 *
 * Returns null when nothing falls outside it.
 */
export const buildSelectionMask = (selection: Feature<Polygon>): Feature<Polygon | MultiPolygon> | null => difference(WORLD, selection);
